// DUIInsuranceFAQSimple.tsx
// ---------------------------------------------------------------------------
// Minimal FAQ accordion with refined styling:
// - Darker gray when expanded
// - Light gray hover with border
// - Bold question text when expanded
// ---------------------------------------------------------------------------

import React from "react";
import { Accordion } from "react-bootstrap";
// import "./FAQ_Component_v02b-simpleCSS.css";

export interface DUIInsuranceFAQ {
  id: number;
  question: string;
  answer: string;
  category: string;
  type: string;
}


export interface DUIInsuranceFAQSimpleProps {
   faqs: DUIInsuranceFAQ[];
  
  /** Open the first item by default (default: true) */
  openFirst?: boolean;
  questionHeaderClassName?: string;
  answerClassName?: string;
}//end:

export const FAQ_Component_v02b_Simple: React.FC<DUIInsuranceFAQSimpleProps> = ({
  faqs,
  openFirst = true,
  questionHeaderClassName,
  answerClassName,

}) => {
  const defaultKey = openFirst && faqs.length ? String(faqs[0].id) : undefined;

  return (
    <Accordion defaultActiveKey={defaultKey} className={answerClassName}>
      {faqs.map((f) => (
        <Accordion.Item eventKey={String(f.id)} key={f.id}>
          <Accordion.Header>
            <span className={questionHeaderClassName}>{f.question}</span>
          </Accordion.Header>
          <Accordion.Body>{f.answer}</Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
};

export default FAQ_Component_v02b_Simple;
